import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { UI_TRANSLATIONS } from './translations';
import { LANGUAGE_SWITCH_ENABLED } from './config';

const STORAGE_KEY = 'fintech_center_language';
const LanguageContext = createContext(null);

const getInitialLanguage = () => {
  if (!LANGUAGE_SWITCH_ENABLED) return 'zh';
  if (typeof window === 'undefined') return 'zh';
  return window.localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'zh';
};

const getByPath = (object, path) =>
  path.split('.').reduce((value, key) => value?.[key], object);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language === 'en' ? 'en' : 'zh-Hant';
    document.title = language === 'en'
      ? 'Fintech Research Center, National Taiwan University'
      : '國立臺灣大學金融科技研究中心';
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    isEnglish: language === 'en',
    t: (path) => getByPath(UI_TRANSLATIONS[language], path)
      ?? getByPath(UI_TRANSLATIONS.zh, path)
      ?? path,
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used inside LanguageProvider');
  }
  return context;
};
